import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  DialogActions,
  Box,
  Paper,
  Typography,
  IconButton,
} from "@mui/material";
import { useFunctions } from "../../hooks/useFunctions";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

const RolForm = ({ open, handleClose, onSubmit, defaultValues = {} }) => {
  const { functions: allFunctions } = useFunctions();
  const { register, handleSubmit, reset } = useForm({ defaultValues });

  const [associatedFunctions, setAssociatedFunctions] = useState([]);
  const [availableFunctions, setAvailableFunctions] = useState([]);

  useEffect(() => {
    if (open) {
      reset(defaultValues);

      const funcionesAsociadas = Array.isArray(defaultValues?.funciones)
        ? defaultValues.funciones
            .filter((id) => id !== null && id !== undefined)
            .map((id) => allFunctions?.find((f) => f.funid === id))
            .filter((f) => f !== undefined)
        : [];

      setAssociatedFunctions(funcionesAsociadas);
      setAvailableFunctions(
        allFunctions
          ? allFunctions.filter(
              (f) => !funcionesAsociadas.some((f2) => f2.funid === f.funid)
            )
          : []
      );
    }
  }, [open, defaultValues, reset, allFunctions]);

  const handleFormClose = () => {
    reset();
    handleClose();
  };

  // 🔹 Agregar funcion desde "Disponibles" a "Asociadas"
  const handleAddFunction = (id) => {
    const functionToAdd = availableFunctions.find((f) => f.funid === id);
    if (functionToAdd) {
      setAssociatedFunctions((functions) => [...functions, functionToAdd]);
      setAvailableFunctions((functions) => functions.filter((f) => f.funid !== id));
    }
  };

  // 🔹 Quitar funcion desde "Asociadas" a "Disponibles"
  const handleRemoveFunction = (id) => {
    const functionToRemove = associatedFunctions.find((f) => f.funid === id);
    if (functionToRemove) {
      setAvailableFunctions((functions) => [...functions, functionToRemove]);
      setAssociatedFunctions((functions) => functions.filter((f) => f.funid !== id));
    }
  };

  const handleFormSubmit = (data) => {
    if (associatedFunctions.length === 0) {
      alert("Debe asociar al menos una funcion para crear el rol.");
      return;
    }
    const funciones = associatedFunctions.map((f) => f.funid);
    onSubmit({ ...data, funciones });
  };

  return (
    <Dialog open={open} onClose={handleFormClose} fullWidth maxWidth="md">
      <DialogTitle>
        {defaultValues?.rolid ? "Editar Rol" : "Crear Rol"}
      </DialogTitle>
      <form onSubmit={handleSubmit(handleFormSubmit)}>
        <DialogContent>
          <TextField label="Nombre del Rol" fullWidth margin="normal" {...register("rolnom")} />
          {/*<TextField label="Descripción del Rol" fullWidth margin="normal" {...register("roldes")} />*/}

          <Box display="flex" gap={2} mt={2}>
            {/* 📌 Funciones Asociadas */}
            <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
              <Typography variant="h6" gutterBottom>
                Funciones Asociadas
              </Typography>
              {associatedFunctions.map((functionx) => (
                <Box key={functionx.funid} display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: 1, mb: 1, borderRadius: 2, backgroundColor: "#fff", boxShadow: 1 }}>
                  <Typography>{functionx.funnom}</Typography>
                  <IconButton color="error" onClick={() => handleRemoveFunction(functionx.funid)}>
                    <RemoveCircleIcon />
                  </IconButton>
                </Box>
              ))}
            </Paper>

            {/* 📌 funciones Disponibles */}
            <Paper sx={{ flex: 1, p: 2, backgroundColor: "#f9f9f9", borderRadius: 2, boxShadow: 3 }}>
              <Typography variant="h6" gutterBottom>
                Funciones Disponibles
              </Typography>
              {availableFunctions.map((functionx) => (
                <Box key={functionx.funid} display="flex" justifyContent="space-between" alignItems="center" width="100%" sx={{ p: 1, mb: 1, borderRadius: 2, backgroundColor: "#fff", boxShadow: 1 }}>
                  <Typography>{functionx.funnom}</Typography>
                  <IconButton color="primary" onClick={() => handleAddFunction(functionx.funid)}>
                    <AddCircleIcon />
                  </IconButton>
                </Box>
              ))}
            </Paper>
          </Box>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleFormClose}>Cancelar</Button>
          <Button type="submit" variant="contained">
            {defaultValues?.funid ? "Actualizar" : "Guardar"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default RolForm;
